export default "__VITE_ASSET__CWIieUqx__"